import ImageComponent from '@components/common/ImageComponent/ImageComponent';
import ivclass from '@invideoio/web-shared/Modules/IVClass';
import { MakeCard } from 'src/types';

interface CardProps {
  card: MakeCard;
}

const Card = (props: CardProps) => {
  const { card } = props;

  const navigateTo = () => {
    if (card.CTAUrl) {
      window.open(card.CTAUrl, '_self');
    } else {
      window.location.reload();
    }
  };

  return (
    <div
      className={ivclass(
        'iv-inline-block',
        'iv-w-[320px] iv-h-[355px]',
        'iv-bg-black-4',
        'iv-rounded-30',
        'iv-my-15 iv-mx-20 md:iv-mx-12 md:iv-my-12 sm:iv-mx-10 sm:iv-my-12',
        'iv-align-top',
      )}
    >
      <div
        className={ivclass(
          'iv-h-full',
          'iv-flex iv-flex-col iv-justify-between iv-items-center',
          'iv-cursor-pointer',
        )}
        onClick={navigateTo}
      >
        <ImageComponent
          elementype="native"
          src={card.image.url}
          alt="card"
          width="100%"
          height="100%"
        />
        <div className={ivclass('iv-h-[85px]')}>
          <div
            className={ivclass(
              'iv-text-body-5xl iv-m-body-5xl xl:iv-text-body-7xl xl:iv-m-body-7xl',
              'iv-font-extrabold',
              'iv-text-center',
            )}
          >
            {card.plainTitle1}
          </div>
          <div
            className={ivclass(
              'iv-text-body-5xl iv-m-body-5xl xl:iv-text-body-7xl xl:iv-m-body-7xl',
              'iv-font-extrabold',
              'iv-text-center',
            )}
          >
            {card.plainTitle2}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
